import loader from './lib/Loader';

import(/* webpackPrefetch: true */ './icons');
loader('slider', '.slider');
loader('navbar', '.header');
loader('menu', '.header');
loader('scroll', '.timeline__column--grid');
// loader('faqheight', '.faq__question-container');
loader('numbers', '.numbers');

// Svelte
loader('newfaq', '.new-faq');

// Searchbar
loader('searchbar', '.post-type-dropdown');
window.onload = async () => {
  let cookieChecked = 0;
  const checkCookie = setInterval(() => {
    if (document.getElementsByClassName('CookieDialog').length) {
      clearInterval(checkCookie);
      import('./cookie').then((module) => module.default());
    }
    cookieChecked += 1;

    if (cookieChecked > 100) {
      clearInterval(checkCookie);
    }
  }, 10);
};
